import { useState, useRef } from 'react'
import { IconButton, Loader, Panel, Popover, Whisper } from 'rsuite'
import CameraRetroIcon from '@rsuite/icons/legacy/CameraRetro'
import CloseIcon from '@rsuite/icons/Close'
import { useCustomTheme } from '../../hooks/useCustomTheme'

const UploaderImage = ({ urlImage, saveMethod, deleteMethod }) => {
  const [uploading, setUploading] = useState(false)
  const [hover, setHover] = useState(false)
  const [imagePreview, setImagePreview] = useState(null)
  const inputProduct = useRef(null)
  const { theme } = useCustomTheme();

  const styleImagem = {
    backgroundColor: '#fff',
    width: 'auto',
    maxWidth: '150px',
    height: 'auto',
    maxHeight: '150px',
    borderRadius: '10px',
    cursor: 'pointer',
  }

  const delay = (ms) => new Promise((res) => setTimeout(res, ms))

  const trocaImagem = async (e) => {
    const file = e.target.files
    setUploading(true)
    await delay(1000)
    if (!file || file.length === 0) {
      return
    }

    saveMethod(file[0])
    setImagePreview(URL.createObjectURL(file[0]))
    setUploading(false)
  }

  return (
    <Panel
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      style={{
        width: 200,
        height: 200,
        borderColor: hover ? theme.colors.primary : theme.colors.lightGrayOpacity
      }}
      bordered
    >
      <>
        {urlImage && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              position: 'absolute',
              marginTop: '-30px',
              zIndex: 1,
              width: 185,
            }}
          >
            <Whisper
              speaker={
                <Popover>
                  <b>Remover imagem</b>
                </Popover>
              }
            >
              <IconButton
                size="xs"
                color="red"
                appearance="primary"
                circle
                icon={<CloseIcon />}
                onClick={deleteMethod}
              />
            </Whisper>
          </div>
        )}
        <input
          ref={inputProduct}
          onChange={trocaImagem}
          type="file"
          id="input"
          hidden
        />
        <button
          style={{
            width: 155,
            height: 155,
            borderRadius: '10px',
          }}
          onClick={() => inputProduct.current.click()}
        >
          {uploading && <Loader backdrop center />}
          {!!imagePreview || !!urlImage ? (
            <img
              style={styleImagem}
              src={imagePreview ? imagePreview : urlImage ? urlImage : ''}
              alt='img-preview'
            ></img>
          ) : (
            <CameraRetroIcon style={{ fontSize: 80, color: 'gray' }} />
          )}
        </button>
      </>
    </Panel>
  )
}

export default UploaderImage;